import Vue from 'vue'
import Router from 'vue-router'
import store from './components/store' // Vuex 用户信息存储

// 按需加载（懒加载）组件，提高页面加载速度
const Login = () => import(/* webpackChunkName: "login_register_home_welcome" */ './pages/Login.vue')
const Home = () => import(/* webpackChunkName: "login_register_home_welcome" */ './pages/Home.vue')
const Register = () => import(/* webpackChunkName: "login_register_home_welcome" */ './pages/Register.vue')
const Welcome = () => import(/* webpackChunkName: "login_register_home_welcome" */ './pages/Welcome.vue')

const DeviceData = () => import(/* webpackChunkName: "device_management" */ './pages/deviceManagement/DeviceData.vue')
const DevicePairing = () => import(/* webpackChunkName: "device_management" */ './pages/deviceManagement/DevicePairing.vue')
const BatchNoManagement = () => import(/* webpackChunkName: "device_management" */ './pages/deviceManagement/BatchNoManagement.vue')
const SerialBurnTool = () => import(/* webpackChunkName: "device_management" */ './pages/deviceManagement/SerialBurnTool.vue')

const UserManagement = () => import(/* webpackChunkName: "setting" */ './pages/setting/UserManagement.vue')
const OperationLog = () => import(/* webpackChunkName: "setting" */ './pages/setting/OperationLog.vue')

const Map = () => import(/* webpackChunkName: "h5" */ './h5/Map.vue')

// 安装 Vue Router 插件
Vue.use(Router)
// 判断是否为生产环境
const isProduction = process.env.NODE_ENV === 'production'
// 根据环境选择路由模式
const routerMode = isProduction ? 'history' : 'hash'
// 定义路由规则
const router = new Router({
  mode: routerMode,
  routes: [
    // 公开页面
    { path: '/', redirect: '/login' },
    { path: '/login', component: Login },
    { path: '/register', component: Register },

    // ========== 独立的全屏地图路由（不经过 Home 布局） ==========
    { path: '/map', component: Map, meta: { title: '地图' } },

    // ========== 带菜单布局的路由 ==========
    {
      path: '/home',
      component: Home,
      redirect: '/welcome',
      children: [
        { path: '/welcome', component: Welcome, meta: { title: '首页' } },
        { path: '/device-data', component: DeviceData, meta: { module: '设备管理', title: '设备数据' } },
        { path: '/device-pairing', component: DevicePairing, meta: { module: '设备管理', title: '设备配对' } },
        { path: '/batchNo-management', component: BatchNoManagement, meta: { module: '设备管理', title: '设备批次' } },
        { path: '/serialBurn-tool', component: SerialBurnTool, meta: { module: '设备管理', title: '写入批次' } },
        { path: '/user-management', component: UserManagement, meta: { module: '设置', title: '用户管理' } },
        { path: '/operation-log', component: OperationLog, meta: { module: '设置', title: '操作日志' } }
      ]
    }
  ]
})

// 路由守卫（导航守卫）
router.beforeEach((to, from, next) => {
  const isAuthenticated = store.getters['globalUserInfo/isAuthenticated']

  // 公开页面路径列表，无需登录即可访问
  const publicPages = ['/login', '/register', '/map']

  if (!isAuthenticated) {
    if (publicPages.includes(to.path)) {
      return next()
    }
    return next('/login')
  }

  // 已登录的情况下，如果访问登录或注册页面，跳转到首页
  if (to.path === '/login' || to.path === '/register') {
    return next('/home')
  }

  // 添加历史记录（Vuex 内部会自动过滤首页）
  if (to.path !== from.path) {
    const route = {
      path: to.path,
      title: to.meta.title || 'Untitled'
    }
    store.dispatch('tabs/addRoute', route)
  }

  next()
})

export default router
